// extracted by mini-css-extract-plugin
export default {"Sponsors":"Sponsors_Sponsors__oqyov","SponsorsContainer":"Sponsors_SponsorsContainer__nw8tR"};